import {_utils} from "../../../utils/_utils.js";
import {_libs} from "../../../utils/_libs.js";
import {afterSubmit, apiUtils, beforeSubmit} from "../../../api/api-utils.js";
import {wpAjaxFunctions} from "../../../api/api.js";
import SignaturePad from "signature_pad";

let signaturePadItem;

export const creditApplicationBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.credit-application', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    // signature
    const canvasItem = section.querySelector('#signature-pad');
    if (canvasItem) {
        signaturePadItem = new SignaturePad(canvasItem, {
            backgroundColor: '#fff',
            penColor: '#000'
        });

        signaturePad(section,signaturePadItem,canvasItem);
    }
    loadTurnstile(function() {
        turnstile.render('#сustom-cf-turnstile', {
            sitekey: '0x4AAAAAACEfucDFzlieNhni',
            callback: function(token) {
                window.turnstileToken = token;
                formRequest(section);
            }
        });
    });

    checkSelectFilled(section);
    thankYouPopup(section);
}

function loadTurnstile(callback) {
    // Якщо turnstile вже завантажений — одразу callback
    if (window.turnstile) {
        callback();
        return;
    }

    // Якщо вже завантажується — чекаємо
    if (window.turnstileLoading) {
        const interval = setInterval(() => {
            if (window.turnstile) {
                clearInterval(interval);
                callback();
            }
        }, 50);
        return;
    }

    window.turnstileLoading = true;

    const script = document.createElement('script');
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;

    script.onload = () => {
        callback();
    };

    document.body.appendChild(script);
}


const signaturePad = (section,signaturePad,canvas)=> {
    const signatureWrapper = section.querySelector('.credit-application__form-block-signature-wrapper');
    const signatureContent = section.querySelector('.credit-application__form-block-signature-content');
    const resetBtn = section.querySelector('#signature-reset');

    resetBtn?.addEventListener('click', () => {
        signaturePad.clear();
        signatureContent.classList.remove('hidden');
    });

    signatureWrapper.addEventListener('mouseenter', hideContent);
    signatureWrapper.addEventListener('mouseleave', showContent);

    signatureWrapper.addEventListener('touchstart', hideContent);
    signatureWrapper.addEventListener('touchend', showContent);

    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();

    function resizeCanvas() {
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
        signaturePad.clear();
    }
    
    function hideContent() {
        signatureContent.classList.add('hidden');
    }

    function showContent() {
        if (signaturePad.isEmpty()) {
            signatureContent.classList.remove('hidden');
        }
    }
}

const addReferences = (section)=> {
    const block = section.querySelector('.credit-application__form-block-references')
    const addBtn = block.querySelector('.credit-application__form-block-add-btn')
    const itemsWrapper = block.querySelector('.credit-application__form-block-items')
    const templateItem = itemsWrapper.querySelector('.credit-application__form-block-container');

    let counter = itemsWrapper.querySelectorAll('.credit-application__form-block-container').length;

    addBtn?.addEventListener('click', async () => {
        const clone = templateItem.cloneNode(true);
        counter++;

        clone.querySelectorAll('input, textarea, select').forEach((el) => {
            el.value = '';

            if (el.type === 'select-one') {
                el.className = '';
                clone.querySelector('.ts-wrapper').remove()
            }
            if (el.name) {
                const baseName = el.name.replace(/\[\d+\]/, '');
                el.name = `${baseName}[${counter}]`;
            }

            if (el.id) {
                const baseId = el.id.replace(/-\d+$/, '');
                el.id = `${baseId}-${counter}`;
            }
        });

        itemsWrapper.appendChild(clone);
        // customSelect();
        await Promise.all([
            _libs._initCustomSelect(),
        ]);
    });
}

const formRequest = (section)=> {
    const form = section.querySelector('form');
    const formBlocks = section.querySelectorAll('.credit-application__form-block');
    const requestData = {
        validationStatus: false,
    };
    const data = {};
    let wpAjaxAction;

    if (form.getAttribute('data-form-type') === 'credit-application') {
        wpAjaxAction = wpAjaxFunctions.creditApplicationAjax;
        // add references

        addReferences(section);


    } else if (form.getAttribute('data-form-type') === 'employee-application') {
        wpAjaxAction = wpAjaxFunctions.employeeApplicationAjax;
    }

    form?.querySelector('button[type=submit]').removeAttribute('disabled');

    form?.addEventListener('submit', e => {
        e.preventDefault();
        formBlocks?.forEach(block=> {
            if (block.classList.contains('credit-application__form-block-references')) {
                const blockData = {
                    items: [],
                }
                const itemsHtml = block.querySelectorAll('.credit-application__form-block-container')

                itemsHtml?.forEach((section,sectionIndex)=> {
                    const sectionItemsArr = [];
                    const items = section.querySelectorAll('input, select, textarea');

                    if (items.length > 0) {
                        items.forEach(item => {
                            const itemData = {
                                required: item.hasAttribute('required'),
                                value: '',
                                closestItem: '',
                                // responseOutput: responseOutput,
                                name: '',
                                type: item.type,
                                fieldValidation: false,
                                fieldSpecialValidation: true,
                            }
                            itemData.name = item.name;
                            if (item.tagName.toLowerCase() !== 'select') {
                                itemData.value = item.value;
                                itemData.closestItem = item.closest('.credit-application__form-block-label');
                                if (item.type === 'email') {
                                    itemData.value = item.value.replace(/\s/g, '');
                                } else if (item.type === 'tel' || item.type === 'text') {
                                    itemData.value = item.value.replace(/\s+/g, ' ').trim();
                                }
                            } else {
                                itemData.closestItem = item.closest('.credit-application__form-block-label');
                                const requiredIndexes = [];
                                const options = item.querySelectorAll('option');
                                if (options.length > 0) {
                                    options.forEach((option, index) => {
                                        if (!option.hasAttribute('disabled')) {
                                            requiredIndexes[index] = option.value;
                                        } else {
                                            requiredIndexes[index] = '';
                                        }
                                    });
                                }
                                itemData.value = requiredIndexes[item.selectedIndex];
                            }
                            // validation fields
                            generalValidation(itemData);

                            sectionItemsArr.push(itemData);
                        });
                        blockData.items[sectionIndex] = sectionItemsArr;
                    }
                })
                data['business_references'] = blockData;
            } else {
                const items = block.querySelectorAll('input, select, textarea');

                // create object of fields
                if (items.length > 0) {
                    items.forEach(item => {
                        const itemData = {
                            required: item.hasAttribute('required'),
                            value: '',
                            closestItem: '',
                            // responseOutput: responseOutput,
                            name: '',
                            type: item.type,
                            fieldValidation: false,
                            fieldSpecialValidation: true,
                        }
                        itemData.name = item.name;
                        if (item.type === 'checkbox') {
                            itemData.checkboxStatus = item.checked;
                        }
                        if (item.type === 'checkbox' && item.name === 'customer-billing-business-types[]') {
                            const checked = document.querySelectorAll('input[name="customer-billing-business-types[]"]:checked');
                            itemData.value = Array.from(checked).map(el => el.value)
                            itemData.closestItem = item.closest('.credit-application__form-block-label');
                        } else if (item.type === 'hidden' && item.name === 'signature-figure') {
                            itemData.closestItem = item.closest('.credit-application__form-block-signature-main');
                            if (signaturePadItem.isEmpty()) {
                                itemData.value =  '';
                                itemData.fieldValidation = false;
                            } else {
                                itemData.value =  signaturePadItem.toDataURL('image/png');
                                itemData.fieldValidation = true;
                            }
                        } else if (item.tagName.toLowerCase() !== 'select') {
                            itemData.value = item.value;
                            itemData.closestItem = item.closest('.credit-application__form-block-label');
                            if (item.type === 'email') {
                                itemData.value = item.value.replace(/\s/g, '');
                            } else if (item.type === 'tel' || item.type === 'text') {
                                itemData.value = item.value.replace(/\s+/g, ' ').trim();
                            }
                        } else {
                            itemData.closestItem = item.closest('.credit-application__form-block-label');
                            const requiredIndexes = [];
                            const options = item.querySelectorAll('option');
                            if (options.length > 0) {
                                options.forEach((option, index) => {
                                    if (!option.hasAttribute('disabled')) {
                                        requiredIndexes[index] = option.value;
                                    } else {
                                        requiredIndexes[index] = '';
                                    }
                                });
                            }
                            itemData.value = requiredIndexes[item.selectedIndex];
                        }
                        // validation field
                        generalValidation(itemData);

                        data[item.name.replace(/[^a-zA-Z0-9]/g, '_')] = itemData;
                    });
                }
            }
        })

        requestData.data = data;
        // form send

        const hasInvalid =
            // check data items
            Object.values(data).some(el =>
                el?.fieldValidation === false || el?.fieldSpecialValidation === false
            ) ||

            // check business_references.items (blocks array)
            data.business_references?.items?.some(block =>
                block.some(item =>
                    item?.fieldValidation === false || item?.fieldSpecialValidation === false
                )
            );


        if (hasInvalid) {
            requestData.validationStatus = false;
            // error message
            section.querySelectorAll('.credit-application__form-response').forEach(response=> response.remove())
            const p = document.createElement("p");
            p.classList.add("credit-application__form-response");
            p.textContent = form.getAttribute('data-fail-validation-message');
            form.appendChild(p);
        } else {
            requestData.validationStatus = true;
            // delete all errors
            section.querySelectorAll('.credit-application__form-response')?.forEach(response=> {
                response.remove();
            })
            // ajax
            let isLoading = false;
           
            let responseData = {};

            sendForm();

            async function sendForm () {
                if(!isLoading){
                    const token = form.querySelector('input[name="cf-turnstile-response"]').value;
                    requestData['cf-turnstile-response'] = token;
                    // const token = await grecaptcha.execute('6LfDpbwrAAAAAOkqwHvO2zS2C0bg1gZwdEWq_B6n', {action: 'submit'});
                    // requestData['g-recaptcha-response'] = token;

                    isLoading = beforeSubmit(section);
                    console.log(requestData)
                    responseData = await apiUtils.getContent(requestData, wpAjaxAction);
                    isLoading = afterSubmit(section, () => {
                        if (responseData !== null) {
                            console.log(responseData)
                            if (responseData.success) {
                                let successMessage;
                                if (responseData?.data?.msg && responseData.data.msg[0]) {
                                    successMessage = responseData.data.msg[0]
                                } else {
                                    successMessage = 'Thank you for your message!'
                                }
                                section.querySelectorAll('.credit-application__form-response')?.forEach(response=> {
                                    response.remove();
                                })
                                window.location.href = window.location.origin + window.location.pathname + "?success=true&success-message="+successMessage;
                            } else if (!responseData.success) {
                                if (responseData.data.err && responseData.data.msg) {
                                    section.querySelectorAll('.credit-application__form-response')?.forEach(response=> {
                                        response.remove();
                                    })
                                    responseData.data.msg.forEach(msg => {
                                        const p = document.createElement("p");
                                        p.classList.add("credit-application__form-response");
                                        p.textContent = msg;
                                        form.appendChild(p);
                                    });
                                }
                            }
                        }
                    });
                }
            }
        }
    });
}

const thankYouPopup = (section)=> {
    const popup = section.querySelector('.credit-application-popup')

    window.addEventListener('click',(e)=> {
        if (e.target.classList.contains('credit-application-popup')) {
            if (popup.classList.contains('active')) {
                popup.classList.remove('active')
            }
        }
    })

    const urlParams = new URLSearchParams(window.location.search);
    const successMessage = urlParams.get('success-message');

    if (successMessage) {
        const popupTitle = section.querySelector('.credit-application-popup__title');

        popupTitle.textContent = decodeURIComponent(successMessage);

        urlParams.delete('success-message');

        const newUrl = urlParams.toString()
            ? `${window.location.pathname}?${urlParams.toString()}`
            : window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
    }
    
}

const checkSelectFilled = (section)=> {
    const selects = section.querySelectorAll('.credit-application__form select');

    selects.forEach(select => {
        const parentBlock = select.closest('.credit-application__form-block-label');

        const checkValid = () => {
            if (select.value.trim() !== '') {
                parentBlock.classList.add('valid');
            } else {
                parentBlock.classList.remove('valid');
            }
        };

        checkValid();

        select.addEventListener('change', checkValid);
    });
}

const generalValidation = (itemData)=> {
    if (itemData.required) {
        if (itemData.type === 'text' || itemData.type === 'email' || itemData.type === 'tel' || itemData.type === 'textarea' || itemData.type === 'select-one') {
            if (itemData.value !== '') {
                itemData.fieldValidation = true;
            } else if (itemData.value === '') {
                itemData.fieldValidation = false;
            }
        } else if (itemData.type === 'number') {
            if (itemData.value !== '' && itemData.value > 0) {
                itemData.fieldValidation = true;
            } else if (itemData.value === '') {
                itemData.fieldValidation = false;
            }
        } else if (itemData.type === 'checkbox') {
            console.log(itemData.checkboxStatus)
            if (itemData.value !== '' && itemData.checkboxStatus) {
                itemData.fieldValidation = true;
            } else if (itemData.value === '' || !itemData.checkboxStatus) {
                itemData.fieldValidation = false;
            }
        }
    } else {
        itemData.fieldValidation = true;
    }
    // email && tel
     if (itemData.type === 'email' && itemData.value !== '') {
        if (isValidEmail(itemData.value)) {
            itemData.fieldSpecialValidation = true;
        } else {
            itemData.fieldSpecialValidation = false;
        }
     } else if (itemData.type === 'tel' && itemData.value !== '') {
        if (isValidPhoneNumber(itemData.value)) {
            itemData.fieldSpecialValidation = true;
        } else {
            itemData.fieldSpecialValidation = false;
        }
     } else {
         itemData.fieldSpecialValidation = true;
     }
    // show\hide error message
    if (itemData.fieldValidation) {
        itemData.closestItem?.classList.remove('novalidate')
    } else {
        itemData.closestItem?.classList.add('novalidate')
    }
    if (itemData.fieldSpecialValidation) {
        itemData.closestItem?.classList.remove('novalidate-special')
    } else {
        itemData.closestItem?.classList.add('novalidate-special')
    }
}

const isValidEmail = (email)=> {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

const isValidPhoneNumber = (phone)=> {
    const phoneRegex = /^\+?[\d\s()-]{7,15}$/;
    return phoneRegex.test(phone);
}
